export default __webpack_public_path__ + "static/media/gears.49153278.gif";